import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
interface IInputField {
  name: "fullName" | "email" | "phoneNumber";
  label: string;
  type: string;
  inputMode?:
    | "search"
    | "text"
    | "email"
    | "tel"
    | "url"
    | "none"
    | "numeric"
    | "decimal";
  hasAsterisk?: boolean;
  maxLength: number;
  sanitize: (value: string) => string;
  isOnStickyRaQ?: boolean;
  isContactForm?: boolean;
}

const InputField = ({
  name,
  label,
  type,
  inputMode,
  hasAsterisk,
  maxLength,
  sanitize,
  isOnStickyRaQ,
  isContactForm = false
}: IInputField): JSX.Element => {
  const [hasSmallLabel, setHasSmallLabel] = useState(false);
  const formContext = useFormContext();

  useEffect(() => {
    // Sets small label on step 2 back button;
    if (formContext.getValues(name)) {
      setHasSmallLabel(true);
    } else {
      setHasSmallLabel(false);
    }
  }, [formContext.watch(name)]);

  const error = formContext.formState.errors[name];
  const labelId = `label-${name}`;

  return (
    <div className={`float-input-container ${isContactForm ? 'contact-us' : ''}`}>
      <input
        type={type}
        id={name}
        aria-labelledby={labelId}
        autoComplete={type}
        aria-label={label}
        maxLength={maxLength}
        className={`${isOnStickyRaQ ? "autofill-bg-white !bg-white" : ""} ${
          error ? "error-field" : ""
        }`}
        inputMode={inputMode || undefined}
        {...formContext.register(name)}
        onChange={(event) => {
          if (error) {
            formContext.clearErrors(name);
          }
          const { value } = event.target;
          event.target.value = sanitize(value);
          setHasSmallLabel(event.target.value.length > 0);

          // setValue is used to fix the autofill bug NAM-2111, couldn't find better solution for now
          formContext.setValue(name, event.target.value);
        }}
      />

      <label
        htmlFor={name}
        id={labelId}
        className={`
        ${hasSmallLabel ? "active-float-label" : ""} `}
      >
        {label}
        {hasAsterisk ? "*" : ""}
      </label>
      {error && <span className="error-text">{error.message as string}</span>}
    </div>
  );
};

export default InputField;
